import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = ['profile--edit-social-networks-modal'];


    openModal(event) {
        event.preventDefault();

        this.profileEditSocialNetworksModalOutlet.openModal();
    }
}
